module.exports = __webpack_public_path__ + "img/5-ExitusMujer.7777ed8d.jpg";